import React, { useMemo, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { DrawerHeader } from "@/components/ui/drawer";
import { CaretLeft, CaretRight, MagnifyingGlass } from "@phosphor-icons/react";
import { Step } from "./constants";
import Card from "@/components/custom/card";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { Input } from "@/components/ui/input";
import { ExpenseFormValues } from "./";
import { Vendor } from "@/lib/types";

const VendorStep = ({
  form,
  setStep,
  vendors,
  isPending,
}: {
  form: UseFormReturn<ExpenseFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  vendors: Vendor[];
  isPending: boolean;
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const filteredVendors = useMemo(() => {
    return vendors.filter((vendor) =>
      vendor.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [vendors, search]);

  return (
    <div>
      <DrawerHeader
        title={t("title.supplier")}
        leftButton={
          <button
            type="button"
            onClick={() => setStep(Step.INITAL)}
            className="w-6"
          >
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-6" />}
      />

      <p className="mx-auto max-w-[210px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.select_supplier")}
      </p>

      <div className="relative mt-5 w-full">
        <MagnifyingGlass
          color="#719BAD"
          className="pointer-events-none absolute left-2 top-1/2 z-10 -translate-y-1/2"
          size={20}
        />
        <Input
          className="pl-10"
          placeholder={t("label.search")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {isPending ? (
        <Loading className="mt-10" />
      ) : (
        <div className="mt-5 space-y-[15px]">
          {filteredVendors?.map((vendor) => (
            <Card
              data-testid={`expense-form-vendor-item-${vendor.id}`}
              onClick={() => {
                form.setValue("vendor", { id: vendor.id });
                setStep(Step.INITAL);
              }}
              className="px-[15px] py-[14px]"
              key={vendor.id}
            >
              <div className="flex flex-col items-start justify-between gap-3">
                <span className="text-[15px] font-medium leading-[18px] text-white">
                  {vendor.name}
                </span>
              </div>
              <CaretRight color="#E3EDFC" size={18} />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorStep;
